import { useState, useEffect } from "react";
import stylez from "./UpdateContacts.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../Configuration/axiosInstance";
import SuccessDialogue from "../../../Components/Shared/SuccessDialog/SuccessDialog";
import LoadingSpinner from "../../../Components/Shared/Loader/Loader";

const UpdateContacts = () => {
  const location = useLocation();
  const [contact, setContact] = useState("");
  const [msg, setMsg] = useState("");
  const [show, setShow] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axiosInstance.get(`customers/${location?.state?._id}`).then((response) => {
      console.log(response);
      setContact(response.data.data);
      setLoading(false);
    });
  }, [refresh]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    event.preventDefault();
    setContact({ ...contact, [name]: value });
  };
  // We then send the data with object id as a parameter which is
  // then handled on the frontend.
  const handleButton = () => {
    setShow(true);
    setMsg("Updating Product in the Database. Please wait...");

    axiosInstance
      .patch(`customers/${location?.state?._id}`, contact)
      .then((response) => {
        setMsg(response.data.message);
        setShow(true);

        setTimeout(() => {
          setMsg();
          setShow(false);
          setRefresh((prevState) => !prevState);
        }, 3000); // Adjust the delay as needed
      })
      .catch((error) => {
        alert(error);
      });
  };

  return (
    <>
      <h2>Update Contact Details</h2>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className={stylez.box}>
          <SuccessDialogue show={show} msg={msg} />
          <div className={stylez.newContainer}>
            <div className={stylez.divs}>
              <label>Business Name:</label>
              <input
                value={contact.businessName}
                type="text"
                name="businessName"
                placeholder="Business Name"
                onChange={handleChange}
              />
              <label>ABN :</label>
              <input
                value={contact.abn}
                type="number"
                name="abn"
                placeholder="ABN"
                onChange={handleChange}
              />
              <label>Address: </label>
              <input
                value={contact.address}
                type="text"
                name="address"
                placeholder="Address"
                onChange={handleChange}
              />
            </div>
            <div className={stylez.divs}>
              <label>Person In Charge</label>
              <input
                value={contact.pic}
                type="text"
                name="pic"
                placeholder="Person In Charge"
                onChange={handleChange}
              />
              <label>Phone:</label>
              <input
                value={contact.phone}
                type="number"
                name="phone"
                placeholder="Business Phone Number"
                onChange={handleChange}
              />
              <label>Email:</label>
              <input
                value={contact.email}
                type="email"
                name="email"
                placeholder="Bussiness Email"
                onChange={handleChange}
              ></input>
            </div>
            <div className={stylez.divs}>
              <label>Comments:</label>
              <input
                value={contact.comments}
                type="text"
                name="comments"
                placeholder="Delivery via n lane"
                onChange={handleChange}
              />

              <label>Customer Type:</label>
              <select
                name="customer_type"
                value={contact.customer_type}
                onChange={handleChange}
              >
                <option>Select an option</option>
                <option value="End User">End User</option>
                <option value="Reseller">Reseller</option>
                <option value="End User & Reseller">End User & Reseller</option>
              </select>
              <hr />
            </div>
          </div>
          <button className="confirmBtn" onClick={handleButton}>
            Update
          </button>
        </div>
      )}
    </>
  );
};
export default UpdateContacts;
